import React from "react";
import styled from "styled-components";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form as BaseForm,
  FormGroup as BaseFormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import Colors from "../../../themes/Colors";
import { UserOutlined } from "@ant-design/icons";
import {
  getEdadFromFecha,
  getTelefonoPrincipal,
} from "../utils/HospitalizacionUtils";

const AfiliadoRight = styled.div`
  flex: 1;
  min-width: 0;
`;

const AfiliadoForm = styled(BaseForm)`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 28px;
  row-gap: 18px;
  align-items: end;

  & > ${BaseFormGroup}:nth-child(1) {
    grid-column: 1 / span 2;
  }
  & > ${BaseFormGroup}:nth-child(2) {
    display: none;
  }
  & > ${BaseFormGroup}:nth-last-child(1),
  & > ${BaseFormGroup}:nth-last-child(2) {
    display: none;
  }
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);

    & > ${BaseFormGroup}:nth-child(1) {
      grid-column: 1 / span 2;
    }
  }

  /* ✅ Mobile: 1 columna */
  @media (max-width: 700px) {
    grid-template-columns: 1fr;

    & > ${BaseFormGroup}:nth-child(1) {
      grid-column: auto;
    }
  }
`;

const AfiliadoFormGroup = styled(BaseFormGroup)`
  min-width: 0;
  width: 100%;
  
  /* Forzar que todos los inputs ocupen el 100% */
  input {
    width: 100% !important;
    height: 37px !important;
    box-sizing: border-box;
  }
`;

const AfiliadoIngresoDetalle = ({ encabezado }) => {
  const empresa = useEmpresa();
  if (!encabezado) return null;

  const edadTexto = getEdadFromFecha(encabezado.fechaNacimiento);
  const telefono = getTelefonoPrincipal(encabezado.telefonos);

  return (
    <FormWrapper
      flexDirection={"row"}
      flex={"1"}
      maxWidth={"100%"}
      borderColor={empresa?.COLOR_PRINCIPAL}
      style={{ width: "100%", padding: "20px" }}
    >
      <FormWrapper
        borderColor={Colors.transparent}
        maxWidth={"120px"}
        style={{
          flex: "0 0 120px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: 90,
            height: 90,
            borderRadius: "50%",
            border: `2px solid ${empresa?.COLOR_PRINCIPAL || "#00a0df"}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 40,
            color: "#777",
          }}
        >
          <UserOutlined style={{ fontSize: 36, color: "#9aa0a6" }} />
        </div>
      </FormWrapper>

      <AfiliadoRight>
        <AfiliadoForm>
          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Nombre"}
              label={"Nombre"}
              value={encabezado.nombreAfiliado || ""}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup />

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Edad"}
              label={"Edad"}
              value={edadTexto}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Número de " + (empresa?.TIPO_CLIENTE || "Afiliado")}
              label={empresa?.TIPO_CLIENTE || "Afiliado"}
              value={encabezado.numeroAsegurado || ""}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Cédula"}
              label={"Cédula"}
              value={encabezado.cedula || ""}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Teléfono"}
              label={"Teléfono"}
              value={telefono}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"NSS"}
              label={"NSS"}
              value={encabezado.nss || ""}
              disabled={true}
            />
          </AfiliadoFormGroup>

          <AfiliadoFormGroup>
            <CustomInput
              type={"text"}
              width={"100%"}
              placeholder={"Plan"}
              label={"Plan"}
              value={encabezado.descripcionPlan || ""}
              disabled={true}
            />
          </AfiliadoFormGroup>
          <AfiliadoFormGroup />
          <AfiliadoFormGroup />
        </AfiliadoForm>
      </AfiliadoRight>
    </FormWrapper>
  );
};

export default AfiliadoIngresoDetalle;
